const React = require('react');

class Wrapper extends React.Component {
  render() {
    if (this.props.showSellerView) {
      return (
        <span className="dropdown inline-block">
          {this.props.children}
        </span>
      );
    } else if (this.props.showBuyerView) {
      return (
        <div className="dropdown previously-bought-from-seller">
          {this.props.children}
        </div>
      );
    }
  }
}

module.exports = Wrapper;



// WEBPACK FOOTER //
// ./javascripts/components/previous_orders/wrapper.jsx